import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import FmStorageEditDto from 'app/admin/fileManager/dto/FmStorageEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class FmStorageEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'fmStorageEditControl';
	}

	/**
	 * @return {Promise<FmStorageEditDto>>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new FmStorageEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<FmStorageEditDto>>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new FmStorageEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {FmStorageEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {FmStorageEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @return {Array.<NamedDto>>}
	 */
	getPermissionListUserSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getPermissionListUserSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Array.<NamedDto>>}
	 */
	getPermissionListUserGroupSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getPermissionListUserGroupSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new FmStorageEditService();
